import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ReceiptListChild from "./ReceiptListChild";

import { useLocation } from "react-router-dom";

const ReceiptList = () => {
  const { state } = useLocation();
  const subscriberRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <ReceiptListChild subscriberRecord={subscriberRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default ReceiptList;
